
import Chihuahua from './districts/colonias_chihuahua.json' assert { type: 'json' };
import Cuauhtemoc from './districts/colonias_cuauhtemoc.json' assert { type: 'json' };

export const getDistricts = (key, edit) =>{

    const keySinAcento = key.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const keys = {
        Chihuahua,
        Cuauhtemoc
    }

    const response = (keys[keySinAcento] || []).map(items => {
        return {label: items.Colonia, value : items.Colonia}
    }).sort((a, b) => (a?.label || '').toLowerCase().localeCompare((b?.label || '').toLowerCase())) 

    if(edit){
        response.unshift({label:edit, value:edit})
    }


    return {data: response, exist: response.length > 0}
 }